    import { useState, useEffect } from 'react';
import BackToMapButton from "../Buttons/BackToMapButton"
import GlobalButtonInjector from '../RevitComponent/GlobalButtonInjector';
import { useNavigate } from "react-router-dom";
import { ChevronLeft, ChevronDown } from 'lucide-react';
import { useMapStore } from '../../store/useMapStore';
import LayerControl from "../MapControls/MapLayerVisibilty"
import { useSitePropertiesStore } from "../../store/useGeometryPropertiesStore"
import SitePropertiesControl from './SemanticProperties/SitePropertiesControl';
import LandusePropertiesControl from './SemanticProperties/LandusePropertiesControl';
import BPlanPropertiesControl from './SemanticProperties/BPlanPropertiesControl';
import BuildingPropertiesControl from './SemanticProperties/BuildingPropertiesControl';
import { useGeometryTypeStore } from '../../store/useGeometryPropertiesStore';
import TopographyPropertiesControl from './SemanticProperties/TopographyPropertiesControl';
import RiskareaPropertiesControl from './SemanticProperties/RiskareaPropertiesControl';
import { useProgressStore } from '../../store/progressStore';

const SidePanel = ({ isOpen, onClose }) => {
  const geometryType = useGeometryTypeStore((state) => state.geometryType);
  const resetprogress = useProgressStore.getState().resetAll;
  const teststate = useProgressStore.getState();
  const [mapKey, setMapKey] = useState(0); 
  const [isCollapsed, setIsCollapsed] = useState(false);
  const currentLocation = useMapStore.getState().currentLocation;
  const home = useMapStore(state => state.home);
  const navigate = useNavigate();
  const updateSitePropertiesStore = useSitePropertiesStore((state) => state.updateSiteProperties);
  const [locationToDisplay, setLocationToDisplay] = useState(null);
 
  const handleBackToMap = () => {
     updateSitePropertiesStore("","", "","")
     resetprogress();
       navigate(-1);
  };



  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };
   useEffect(() => {
      
      console.log(currentLocation)
    }, []);

  return (
    <>
      {/* Side Panel */}
      <div
        style={{
          position: 'fixed',
          top:isCollapsed ? "84px":"60px",
          width: '336px',
          height: isCollapsed ? '135px' : 'calc(100vh - 60px)', 
          backgroundColor: 'white',
          borderRight: '1px solid #e2e8f0',
          transition: 'left 0.3s ease-in-out, height 0.3s ease-in-out',
          zIndex: 40,
          display: 'flex',
          flexDirection: 'column',
          borderRadius: isCollapsed ? "15px":"0px",
          left: isCollapsed ? "24px" : (isOpen ? "0px" : "-336px"),
          overflowY: 'auto',
          scrollbarWidth: 'thin',
         
        }}
      >
        <div style={{ 
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          padding: '12px 16px',
          borderBottom: '1px solid #e2e8f0',
          backgroundColor: 'white',
          position: 'relative',
          zIndex: -41,
          minHeight: '130px',
          height:"130px"
        }}        >
          <div style={{ position: 'absolute', left: '20px', width:"254px", height:"21px",top:"8px"}}>
           
            <BackToMapButton onClick={handleBackToMap} />  
            <p style={{ 
            color: '#27292B', 
            marginBottom: '16px',
            marginLeft:"6px",
            position:"absolute",
            top:"30px",
            fontFamily:"GoldbeckNextSemiBold2",
            fontWeight:"800",
            fontSize:"18px"
            }}>
              Lageplan 
            </p>
              <p style={{ 
            color: '#27292B', 
            marginBottom: '16px',
            marginLeft:"6px",
            position:"absolute",
            top:"70px",
            fontFamily:"GoldbeckNextRegular",
            fontSize:"13px",
            fontWeight:"400"
            }}>
              {currentLocation}
           
            </p>
          </div>
          
          
          
          <button
            onClick={toggleCollapse}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '1.2rem',
              cursor: 'pointer',
              outline:"none",
              padding: '4px 8px',
              borderRadius: '4px',
              transition: 'color 0.2s ease',
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
              marginTop:"-80px",
              marginLeft:"-30px",
              marginRight:"-12px"
            }}
            onMouseEnter={(e) => e.target.style.color = '#27292B'}
            onMouseLeave={(e) => e.target.style.color = '#27292B'}
          >
          {isCollapsed? (
                     <ChevronLeft size={16} color="#6B7280" />
                   ) : (
                     <ChevronDown size={16} color="#6B7280" />
                   )}
          </button>
        </div>
        
       
        <div 
          style={{ 
            flex: 1,
            padding: '16px',
            overflow: 'auto',
            opacity: isCollapsed ? 0 : 1,
            transition: 'opacity 0.3s ease',
            position: 'relative',
            zIndex: 39 
          }}
        >
          <LayerControl></LayerControl>
          <div>
            {geometryType === 'FlurstuckEntity' && <SitePropertiesControl />}
            {geometryType === 'LanduseEntity' && <LandusePropertiesControl />}
            {geometryType === 'LOD2BuildingEntity' && <BuildingPropertiesControl />}
            {geometryType === 'BPlanEntity' && <BPlanPropertiesControl />}
            {geometryType === 'TopographyEntity' && <TopographyPropertiesControl />}
            {geometryType === 'RiskAreaEntity' && <RiskareaPropertiesControl />}
          </div>
          <div style={{
             flex: 1,
              padding: "8px 8px",
              overflow: 'auto',
              opacity: isCollapsed ? 0 : 1,
              transition: 'opacity 0.3s ease',
              position: 'relative',
              zIndex: 50,
              left:"35px",
              position: 'relative',
              paddingBottom: '60px',
              marginLeft:"-20px"
          }}>
            <GlobalButtonInjector/>
          </div>
        </div>
      </div>
    </>
  );
};

export default SidePanel;